module.exports = __webpack_public_path__ + "img/cospirit-tree.0575880c.svg";